import { join } from 'light-component';
import { Icons, Box, Block, useTranslation } from '@common';
import '../../styles/index.less';
import styles from '../style.module.less';
import { DragItem, Highlighter } from '../../component';
import { useBeforeColor, usePrimaryColor } from '../../hooks';
import { IconNamesMaps, Icon } from './icon';
import type { ReactElement } from 'react';
import type { BlockProps } from './types';

export function BlockDesignMode(props: BlockProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor, hexColor } = usePrimaryColor();
  const className = 'widget-block';
  useBeforeColor(className, hexColor);

  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('ShotEyesBlock')} />
    );
  }
  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      onClick={() => props.onWidgetChange('fold', props.name ?? '')}
      style={{ ...activeStyle, cursor: 'pointer' }}
      className={join(styles.designBox, className)}>
      <Box className={`${styles.subject} block-subject`}>
        <Block if={Object.keys(IconNamesMaps).includes(props.blockIcon)}>
          <span className={styles.icon}>
            <Icon name={props.blockIcon} />
          </span>
        </Block>
        <Block if={!Object.keys(IconNamesMaps).includes(props.blockIcon)}>
          <Icons name='BlockIcon' className={styles.icon} />
        </Block>
        <Highlighter
          title={props.description}
          keyword={props.keyword}
          className={styles.title}
        />
        <Block if={props?.score != null}>
          <div>
            {`(${t('{score}分', { score: props.score })})`}
          </div>
        </Block>
        <Block if={props?.weight != null}>
          <div>
            {`(${t('权重{weight}', { weight: props.weight })})`}
          </div>
        </Block>
      </Box>
    </Box>
  );
}
